import { getMuiTheme } from 'material-ui/styles';
import EnhancedButton from 'material-ui/internal/EnhancedButton';
import EnhancedSwitch from 'material-ui/internal/EnhancedSwitch';
import IconButton from 'material-ui/IconButton';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';

// Disable touch ripples
(EnhancedButton as any).defaultProps.disableTouchRipple = true;
(EnhancedButton as any).defaultProps.disableFocusRipple = true;

(IconButton as any).defaultProps.disableTouchRipple = true;
(RaisedButton as any).defaultProps.disableTouchRipple = true;
(FlatButton as any).defaultProps.disableTouchRipple = true;

(EnhancedSwitch as any).defaultProps = {
    disableTouchRipple: true,
    disableFocusRipple: true,
};

// =======================================================================================================
export function getMUITheme() {
    return getMuiTheme({
        fontFamily: 'Yodiwo Fonts',
        appBar: {
            height: 40, // Instead of 64
        },
        toolbar: {
            height: 45
        },
        button: {
            iconButtonSize: 36
        },
        baseTheme: {
            spacing: {
                iconSize: 20
            }
        },
        rawTheme: {
            spacing: {
                iconSize: 20
            }
        },
        spacing: {
            iconSize: 20
        }
    });
}
// =======================================================================================================